'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';
import { useAdGuards } from '../_hooks/useAdGuards';
interface AdpopcornProviderProps {
  children?: ReactNode;
}
export const AdpopcornProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    isMounted,
    isWelloApp,
    isExternalWebview
  } = useAdGuards();
  const isReady = isMounted && isWelloApp && !isExternalWebview;
  const memberOAuth = useAuthStore(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: MESSAGE_KEYWORD.SET_ADPOPCORN_USER_ID
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    request
  } = useHandleApp(t1);
  const lastSentRef = useRef(null);
  let t2;
  let t3;
  if ($[1] !== isReady || $[2] !== memberOAuth || $[3] !== request) {
    t2 = () => {
      if (!isReady) {
        return;
      }
      if (!memberOAuth) {
        return;
      }
      const userId = String(memberOAuth);
      if (lastSentRef.current === userId) {
        return;
      }
      lastSentRef.current = userId;
      request({
        userId
      });
    };
    t3 = [isReady, memberOAuth, request];
    $[1] = isReady;
    $[2] = memberOAuth;
    $[3] = request;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== children) {
    t4 = <>{children}</>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(state) {
  return state.myInfo?.memberOAuth;
}